import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { tap } from 'rxjs';
import { LoadingService } from '../loading/loading.service';

export const httpLoadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const loadingService: LoadingService = inject(LoadingService);
  loadingService.showLoadingComponent(req.url);
  return next(req).pipe(
    tap({
      finalize: () => {
        loadingService.closeLoadingComponent(req.url);
      },
    })
  );
};
